/* 质保资格查询器（Check eligibility）
   结果口径（用户 2026-10-10 口径 + Figma 6 张结果卡）：按「是否已购 + 车型年 + 购买日期」出 6 种结果，
   每种结果一张卡、文案全部来自编辑器设置（s1_…s6_ 前缀）：
     s1 未购买（选 No）× 车型年 2025/2026            → 稿内静态「60 DAYS」
     s2 已购 × 车型年 2025/2026 × 购买日 ≥ 政策生效日（默认 2026-10-19）且在 60 天内 → 剩余 ＝ 60 − 已过
     s3 同上，但已过 61–180 天                        → 剩余 ＝ 180 − 已过
     s4 已购 × 车型年 2025/2026 × 购买年在 2026 且早于生效日 → 剩余 ＝ 2026-12-31 − 今天
     s5 购买年为 2025（付费路径）                      → 剩余 ＝ 2026-12-31 − 今天
     s6 车型年 ≤ 2024 或购买年 ≤ 2024（不支持升级，稿内无天数）
     （已过 180 天 ⇒ 暂按 s6 兜底，待产品确认）
   剩余天数：把「N DAYS」写入当前卡片的 [data-vl-we-days]；s1／s6 保留稿内静态文案。
   步骤 1 选「No」：隐藏步骤 3（购买日期）且购买日期不必填；步骤 2 两种情况下都必填；
   提交按钮在必填项未填齐前不可点（disabled + 50% 透明）。
   结果态右上角「返回重新选择」按钮：清空选择并回到表单态。
   车型下拉的每个 option 由 `model` block 提供（车型名 + 车型年 + 关联产品），顺序即 block 顺序；
   「No」结果卡（s1）：关联产品存在 ⇒ 按钮换成去 PDP 的按钮；产品被删除/未发布 ⇒ 禁用灰胶囊。
   多实例：以 [data-vl-we] 根节点为作用域，逐实例初始化（规范 3.10）。 */
(function () {
  var ROOT_SELECTOR = '[data-vl-we]';
  var LEGACY_ATTR = 'data-vl-we-legacy-year';
  var PAID_ATTR = 'data-vl-we-paid-year';
  var MS_PER_DAY = 86400000;
  /* 整日差（忽略时分秒与时区），to - from */
  function daysBetween(from, to) {
    var a = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
    var b = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());
    return Math.round((b - a) / MS_PER_DAY);
  }

  /* 读根节点上的数值设置，缺失/非法时回落默认值 */
  function num(root, attr, fallback) {
    var value = parseInt(root.getAttribute(attr), 10);
    return isNaN(value) || value <= 0 ? fallback : value;
  }

  function toYear(value) {
    var year = parseInt(value, 10);
    return isNaN(year) ? null : year;
  }

  /* 「YYYY-MM-DD」⇒ 当天 0 点的本地 Date；非法返回 null */
  function toDateOnly(value) {
    if (!value) return null;
    var parts = String(value).split('-');
    if (parts.length < 3) return null;
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var day = parseInt(parts[2], 10);
    if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
    return new Date(year, month - 1, day);
  }

  /* 政策日期：根节点属性缺失/非法时回落默认值（防御 section 标记尚未同步到最新版本的情形）；
     用于场景文案切换：结果 3 的「存量」＝购买日在政策生效日之前（新口径「结果 B」也以此为界） */
  function policyDate(root, attr, fallback) {
    return toDateOnly(root.getAttribute(attr)) || toDateOnly(fallback);
  }

  /* 读取表单 ⇒ 结果对象 { state, origin, days, productUrl }
     · state: s1–s6（见文件头口径）
     · origin: 'no'（未购买，不填购买日期）／'yes'
     · days: 该状态要显示的剩余天数（s1/s6 为 null ⇒ 保留稿内静态文案）
     · productUrl: 选中车型关联产品的 PDP（产品被删除/未发布时为空字符串）
     返回 null 表示不产出结果（必填项未齐）。 */
  function readResult(root) {
    var form = root.querySelector('[data-vl-we-form]');
    if (!form) return null;

    var ownsField = form.elements.owns;
    var modelField = form.elements.model;
    var dateField = form.elements.purchase_date;
    var option = modelField && modelField.selectedOptions ? modelField.selectedOptions[0] : null;
    var owns = ownsField ? ownsField.value : null;

    // 步骤 2（车型）两种情况下都必填
    if (!owns || !option || !option.value) return null;

    var modelYear = toYear(option.getAttribute('data-vl-we-year'));
    if (modelYear === null) return null;

    var legacyMax = toYear(root.getAttribute(LEGACY_ATTR));
    var freeDays = num(root, 'data-vl-we-free-days', 60);
    var totalDays = num(root, 'data-vl-we-total-days', 180);
    var effective = policyDate(root, 'data-vl-we-policy-date', '2026-10-19');
    var deadline = policyDate(root, 'data-vl-we-policy-deadline', '2026-12-31');
    var today = new Date();

    var result = {
      origin: owns === 'yes' ? 'yes' : 'no',
      productUrl: option.getAttribute('data-vl-we-product-url') || '',
      // 2026-10-16：加购时的 line item property（车型；用户 2026-10-16 明确不要车型年）
      model: option.value,
      modelYear: modelYear,
      days: null,
      state: 's1'
    };

    // 「No」未购买：车型年 ≤ 上限 ⇒ s6（不支持升级）；否则 s1（购买后 60 天注册窗口，稿内静态天数）
    if (result.origin === 'no') {
      result.state = legacyMax !== null && modelYear <= legacyMax ? 's6' : 's1';
      return result;
    }

    // 「Yes」：购买日期必填
    if (!dateField || !dateField.value) return null;
    var purchase = toDateOnly(dateField.value);
    if (!purchase) return null;
    var purchaseYear = purchase.getFullYear();

    // ① 车型年 ≤ 上限，或购买年 ≤ 上限 ⇒ s6（不支持升级）
    if ((legacyMax !== null && modelYear <= legacyMax) || (legacyMax !== null && purchaseYear <= legacyMax)) {
      result.state = 's6';
      return result;
    }

    // ② 购买年 ≤ 付费年份上限（默认 2025）⇒ s5（付费路径，窗口到 2026-12-31）
    var paidMax = toYear(root.getAttribute(PAID_ATTR));
    if (paidMax !== null && purchaseYear <= paidMax) {
      result.state = 's5';
      result.days = deadline ? Math.max(0, daysBetween(today, deadline)) : null;   /* 截止日已过 ⇒ 0，不显示负数（更细的「已过期」展示待产品确认） */
      return result;
    }

    // ③ 购买日早于政策生效日（2026 年但早于 10-19）⇒ s4（免费路径，窗口到 2026-12-31）
    if (effective && purchase < effective) {
      result.state = 's4';
      result.days = deadline ? Math.max(0, daysBetween(today, deadline)) : null;   /* 截止日已过 ⇒ 0，不显示负数（更细的「已过期」展示待产品确认） */
      return result;
    }

    // ④ 政策生效日之后购买：按已过天数分档
    var elapsed = Math.max(0, daysBetween(purchase, today));
    if (elapsed <= freeDays) {
      result.state = 's2';
      result.days = Math.max(0, freeDays - elapsed);
      return result;
    }
    if (elapsed <= totalDays) {
      result.state = 's3';
      result.days = Math.max(0, totalDays - elapsed);
      return result;
    }

    // ⑤ 超过 180 天：暂按「不支持升级」兜底（旧材料的「例外 C·没有路径」），待产品确认
    result.state = 's6';
    return result;
  }

  /* 把「N DAYS」写入当前卡片（s1／s6 的 days 为 null ⇒ 保留稿内静态文案） */
  function applyDays(root, result, panel) {
    if (!panel || result.days === null || typeof result.days === 'undefined') return;
    var el = panel.querySelector('[data-vl-we-days]');
    if (!el) return;
    var unit = root.getAttribute('data-vl-we-days-unit') || 'DAYS';
    el.textContent = result.days + ' ' + unit;
  }

  function isComplete(form) {
    var owns = form.elements.owns;
    var model = form.elements.model;
    var date = form.elements.purchase_date;
    if (!owns || !model || !model.value) return false;
    if (owns.value === 'yes' && (!date || !date.value)) return false;
    return true;
  }

  /* Date ⇒ 「YYYY-MM-DD」（本地时区，供 input[type=date] 的 min/max 用） */
  function toInputDate(date) {
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return date.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
  }

  /* 购买日期的可选范围（用户 2026-10-10）：
     · 下限＝所选车型年的 1 月 1 日（例：2026 车型不可能在 2025 年购买；2025 车型仍可在 2026 年购买 ⇒ 只卡下界）
     · 上限＝今天（购买日期不可能晚于当天）
     · 未选车型 ⇒ 不设下限（上限仍为今天）
     · 「先选日期、后选车型」（或换车型）若导致日期越界 ⇒ 清空该日期（用户要求）
     触发点：applyFormState（表单 change/input 与初始化都会走到）。 */
  function applyDateRange(root) {
    var form = root.querySelector('[data-vl-we-form]');
    if (!form) return;
    var modelField = form.elements.model;
    var dateField = form.elements.purchase_date;
    if (!modelField || !dateField) return;

    var option = modelField.selectedOptions ? modelField.selectedOptions[0] : null;
    var year = option && option.value ? toYear(option.getAttribute('data-vl-we-year')) : null;

    // 上限：今天
    var max = toInputDate(new Date());
    if (dateField.max !== max) dateField.max = max;

    // 下限：车型年的 1/1；未选车型 ⇒ 移除
    if (year !== null) {
      var min = year + '-01-01';
      if (dateField.min !== min) dateField.min = min;
    } else if (dateField.hasAttribute('min')) {
      dateField.removeAttribute('min');
    }

    // 越界清理（ISO 字符串可直接字典序比较）
    if (dateField.value) {
      var value = dateField.value;
      if ((dateField.min && value < dateField.min) || (dateField.max && value > dateField.max)) {
        dateField.value = '';
      }
    }
  }

  function applyFormState(root) {
    var form = root.querySelector('[data-vl-we-form]');
    if (!form) return;

    // ① 先按当前车型收敛购买日期的可选范围（并清理越界值），再算必填状态
    applyDateRange(root);

    var owns = form.elements.owns;
    var date = form.elements.purchase_date;
    var dateStep = root.querySelector('[data-vl-we-step="date"]');
    var submit = root.querySelector('[data-vl-we-submit]');
    var isNo = !!owns && owns.value === 'no';

    // ② 「No」隐藏步骤 3；购买日期在「No」时不必填
    if (dateStep) dateStep.classList.toggle('is-hidden', isNo);
    if (date) date.required = !isNo;

    // ②b 「No」时把步骤 2 的问题换成另一句（可在编辑器配置 step2_question_no）；
    //     未配置 No 版本文案时（NO_VARIANT 不存在）保持默认问题不切换
    var noLabel = root.querySelector('[data-vl-we-step2-text="no"]');
    if (noLabel) {
      var step2Texts = root.querySelectorAll('[data-vl-we-step2-text]');
      for (var t = 0; t < step2Texts.length; t++) {
        var isNoVariant = step2Texts[t].getAttribute('data-vl-we-step2-text') === 'no';
        step2Texts[t].hidden = isNoVariant !== isNo;
      }
    }

    // ③ 提交按钮：必填项填齐才可点
    if (submit) {
      var complete = isComplete(form);
      submit.disabled = !complete;
      submit.classList.toggle('is-inactive', !complete);
    }
  }

  function focusFirstIncomplete(form) {
    var fields = form.querySelectorAll('select, input');
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i].checkValidity()) {
        fields[i].focus();
        return;
      }
    }
  }

  /* 结果态 → 表单态：清空选择、去掉结果高亮与「No」态禁用，并把焦点交给步骤 1 控件 */
  function resetToForm(root) {
    var form = root.querySelector('[data-vl-we-form]');
    var card = root.querySelector('[data-vl-we-card]');
    if (!form || !card) return;

    if (form.reset) form.reset();

    var panels = root.querySelectorAll('[data-vl-we-result]');
    for (var i = 0; i < panels.length; i++) panels[i].classList.remove('is-active');
    card.classList.remove('is-result');
    applyFormState(root);

    var owns = form.elements.owns;
    if (owns && owns.focus) owns.focus({ preventScroll: true });
  }

  /* 「No」路径的按钮切换：当前结果卡的主按钮 ↔ Shop Now（产品存在）/ 禁用灰胶囊（产品不存在） */
  function applyResultCta(panel, result) {
    if (!panel) return;

    var shop = panel.querySelector('[data-vl-we-shop-now]');
    var shopOff = panel.querySelector('[data-vl-we-shop-now-disabled]');
    /* 「No」（未购买）把主按钮换成 Shop Now／禁用灰胶囊的只有 **s1**（车型年 2025/2026）；
       s6（车型年 ≤2024，无论「Yes」还是「No」）都没有 Shop Now 变体
       ⇒ 若按 `origin === 'no'` 一律隐藏，会把 s6 的「View 2-Year* Warranty Policy」也一起隐藏，
       导致「No + ≤2024 车型」的结果卡一个按钮都没有（2026-10-13 用户反馈）。 */
    var useShop = result.origin === 'no' && result.state === 's1';
    var hasProduct = !!result.productUrl;
    var actions = panel.querySelectorAll('.vl-we__result-actions > *');

    for (var i = 0; i < actions.length; i++) {
      var el = actions[i];
      if (el === shop || el === shopOff) continue;
      if (useShop) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    }

    if (shop) {
      if (useShop && hasProduct) {
        shop.setAttribute('href', result.productUrl);
        shop.removeAttribute('hidden');
      } else {
        shop.removeAttribute('href');
        shop.setAttribute('hidden', '');
      }
    }
    if (shopOff) {
      if (useShop && !hasProduct) shopOff.removeAttribute('hidden');
      else shopOff.setAttribute('hidden', '');
    }
  }

  /* ---------- 结果卡「直接加购」（2026-10-16 用户指令） ----------
     质保页 s3／s5 的主按钮改为把延保产品加入购物车（不再跳 PDP），行上带车型
     line item property（`Model` / `Model Year`）。按钮靠 `form="<隐藏 product-form 的 id>"` 提交，
     交给主题原生 AJAX／抽屉／埋点；本段只做两件事：写 property 字段 + 按钮 loading 反馈。 */

  // 把用户选中的车型写进隐藏字段（页面与 PDP 弹窗共用同一套 `data-vl-we-model-input` 契约）
  function applyAtcProperties(root, result) {
    var btn = root.querySelector('[data-vl-we-plan-atc], [data-vl-pdp-elig-atc]');
    var formId = btn && btn.getAttribute('form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;
    var modelInput = form.querySelector('[data-vl-we-model-input]');
    if (modelInput) modelInput.value = result.model || '';
  }

  var ATC_LOADING_CLASS = 'vl-we__btn--loading';
  var ATC_TIMEOUT = 15000; // ms；失败/异常时兜底复位
  var atcBtn = null;
  var atcTimer = null;

  function paintAtc(btn, on) {
    if (!btn) return;
    if (on) btn.classList.add(ATC_LOADING_CLASS);
    else btn.classList.remove(ATC_LOADING_CLASS);
    if (on) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
    var spinner = btn.querySelector('[data-vl-we-atc-spinner]');
    if (spinner) {
      if (on) spinner.removeAttribute('hidden');
      else spinner.setAttribute('hidden', '');
    }
  }

  function stopAtcLoading() {
    if (atcTimer) {
      clearTimeout(atcTimer);
      atcTimer = null;
    }
    paintAtc(atcBtn, false);
    atcBtn = null;
  }

  /* 包装该表单所属 `<product-form>` 的 `setLoading`：主题开始/结束 AJAX 时同步本按钮的转圈态
     （主题只切换表单内部的 `button[type=submit]`，而本按钮在表单之外 ⇒ 必须自己同步）。 */
  function bindAtcLoading(form) {
    var host = form && form.closest ? form.closest('product-form') : null;
    if (!host || host.vlWeAtcLoadingBound === '1') return;
    host.vlWeAtcLoadingBound = '1';
    if (typeof host.setLoading !== 'function') return;
    var originalSetLoading = host.setLoading;
    host.setLoading = function (isLoading) {
      originalSetLoading.call(host, isLoading);
      if (isLoading) {
        if (atcBtn) paintAtc(atcBtn, true);
      } else {
        stopAtcLoading();
      }
    };
  }

  function startAtcLoading(btn, form) {
    atcBtn = btn;
    paintAtc(btn, true);
    if (atcTimer) clearTimeout(atcTimer);
    atcTimer = setTimeout(stopAtcLoading, ATC_TIMEOUT);
    bindAtcLoading(form);
  }

  function showResult(root, result) {
    var card = root.querySelector('[data-vl-we-card]');
    var panels = root.querySelectorAll('[data-vl-we-result]');
    if (!card) return;

    var active = null;
    for (var i = 0; i < panels.length; i++) {
      var isActive = panels[i].getAttribute('data-vl-we-state') === result.state;
      panels[i].classList.toggle('is-active', isActive);
      if (isActive) active = panels[i];
    }

    card.classList.add('is-result');
    applyResultCta(active, result);
    applyAtcProperties(root, result);
    applyDays(root, result, active);

    if (active) {
      active.setAttribute('tabindex', '-1');
      active.focus({ preventScroll: true });
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-vl-we-ready') === 'true') return;
    var form = root.querySelector('[data-vl-we-form]');
    if (!form) return;

    root.setAttribute('data-vl-we-ready', 'true');

    form.addEventListener('change', function () {
      applyFormState(root);
    });
    form.addEventListener('input', function () {
      applyFormState(root);
    });
    applyFormState(root); // 初始化（含浏览器回填／后退恢复出的「No」态与按钮可用性）

    var back = root.querySelector('[data-vl-we-back]');
    if (back) {
      back.addEventListener('click', function () {
        resetToForm(root);
      });
    }

    // 结果卡「直接加购」按钮：提交交给主题原生表单，这里只启动按钮转圈反馈（capture ⇒ 先于主题处理）
    root.addEventListener(
      'click',
      function (event) {
        var btn = event.target && event.target.closest ? event.target.closest('[data-vl-we-plan-atc]') : null;
        if (!btn) return;
        var formId = btn.getAttribute('form');
        startAtcLoading(btn, formId ? document.getElementById(formId) : null);
      },
      true
    );

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var result = readResult(root);
      if (!result) {
        focusFirstIncomplete(form);
        return;
      }
      showResult(root, result);
    });

    // 结果卡里指向页内锚点的按钮（如 s6 的「View 2-Year* Warranty Policy」）：
    // 平滑滚动到目标（让出悬浮条高度），并把目标里折叠的手风琴展开（走既有动画）
    root.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href^="#"]') : null;
      if (!link) return;

      var hash = link.getAttribute('href');
      if (!hash || hash.length < 2) return;

      var target = document.getElementById(hash.slice(1));
      if (!target) return;

      event.preventDefault();

      var nav = document.querySelector('.vl-pdp-sticky-anchor-nav');
      var offset = nav ? nav.offsetHeight : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      try {
        window.scrollTo({ top: top < 0 ? 0 : top, behavior: reduce ? 'auto' : 'smooth' });
      } catch (err) {
        window.scrollTo(0, top < 0 ? 0 : top);
      }

      // 目标是手风琴卡 ⇒ 展开它；目标是段落 ⇒ 展开段落里第一张折叠的卡
      var details = target.tagName === 'DETAILS' ? target : target.querySelector('details');
      if (details && !details.open) {
        var summary = details.querySelector('summary');
        if (summary) {
          summary.click(); // 触发现有手风琴的高度过渡动画
        } else {
          details.open = true;
        }
      }

      if (window.history && window.history.replaceState) window.history.replaceState(null, '', hash);
    });
  }

  function boot(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var roots = host.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
    if (host !== document && host.matches && host.matches(ROOT_SELECTOR)) init(host);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
